import { Box, Grid, Button, Paper } from '@mui/material';
import { LoftForFitting } from '../classes/Golfer';
import { ActiveShotCoordinate } from './FittingBL';
import * as FittingBL from './FittingBL';

export default function FittingYourShots(props: any){
    const loftsForFitting = props.loftsForFitting as LoftForFitting[];
    const activeShotCoordinate = props.activeShotCoordinate as ActiveShotCoordinate;
    const lastShotCoordinate = props.lastShotCoordinate as ActiveShotCoordinate;
    const handleDeleteLastShot = props.handleDeleteLastShot;
    const handleSelectNewShotRow = props.handleSelectNewShotRow;
    const golfer = props.golfer;
    const fitter = props.fitter;
    const intl = props.intl;

    const intlDeleteLastShot = intl.formatMessage({id:"now.hitting.delete"})
    const intlDistance = FittingBL.getNowHittingYards(activeShotCoordinate, golfer, fitter, intl);

    return (
        <Paper>
        <Grid container className='row' sx={{ marginTop: '10px !important' }}>
        </Grid>
        {loftsForFitting.map((loft, loftIx) => {
            return (
                <Box key={loftIx} className={`aa ${loftIx === activeShotCoordinate.row ? 'active-row' : 'non-active-row'} `} sx={{ paddingBottom: '0px !important' }} >
                    <Grid container className="custom-height" sx={{ marginTop: '0px !important', height: 'auto', paddingTop: '5px' }} onClick={() => { handleSelectNewShotRow(loftIx) }}>
                        <Grid item xs={5} sx={{ paddingLeft: '0px' }}>
                            <Button disableRipple value={loftIx} sx={{ textAlign: 'left', paddingLeft: '10px', color: 'black', textTransform: 'capitalize', paddingBottom: "0px", '&:hover': { backgroundColor: 'transparent' }, '&:active': { backgroundColor: 'transparent' } }}>
                                {loft.loft + ' ' + intl.formatMessage({id: "shot.selection."+(loft.shotType.toLowerCase()).replace(' ', '')}) }
                            </Button>
                        </Grid>
                        <Grid item xs={7}>
                            <Grid container className='row' sx={{ textAlign: 'left' }}>
                                {loft.practiceShots.map((completed, completedIx) => {
                                    return (
                                        <div key={completedIx}>
                                            <Button disableRipple variant="contained" className={`fitted-shot ${completed.status}`} sx={{}}></Button>
                                        </div>
                                    )
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sx={{ fontSize: '10px', marginTop: '0px', marginLeft: { 'xs': '25px', 'md': '100px', 'lg': '25px' }, color: 'gray', minHeight: '5px' }}>
                        {loft.shotType === 'Pitch' && loftIx === activeShotCoordinate.row && <>
                            {intlDistance}
                        </>}
                        {loft.shotType === 'Open Face' && loftIx === activeShotCoordinate.row && <>
                            {intlDistance}
                        </>}
                    </Grid>
                </Box>
            )
        })}

        <Grid container className='row' sx={{ marginTop: '10px !important' }}>
        </Grid>
        <Box sx={{ flexGrow: 1 }} className='navbar'>
            <div className='appbar' style={{ textAlign: 'left', paddingBottom: '0px' }}>
                <Button disableRipple type="submit" disabled={lastShotCoordinate.row === -1} onClick={handleDeleteLastShot} className='delete-last-shot'>{intlDeleteLastShot}</Button>
            </div>
        </Box>
    </Paper>
    )
}